import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class AuthenticatedCareerPathwaysExploreCompareRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;

  async model() {
    const allRoles = await this.reimaginedData.fetchAllRolesForComparison();
    return { allRoles };
  }
}
